import ErrorBoundary from './ErrorBoundaryContainer'

export default ErrorBoundary
